import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terms-and-conditions-dialog',
  templateUrl: './terms-and-conditions-dialog.component.html',
  styleUrls: ['./terms-and-conditions-dialog.component.scss']
})
export class TermsAndConditionsDialogComponent implements OnInit {
  readonly message: string = 'We use cookies to improve your user experience and journey with us. By clicking "Accept", you agree Entire OnHire can store cookies on your device with the user\'s non-sensitive information for auto-login to retain your session.';

  constructor() { }

  ngOnInit(): void {
  }

}
